import React from 'react';
import PropTypes from 'prop-types';

import { clientError } from '../../lib/errorReporting';

class ErrorBoundary extends React.Component {
  componentDidCatch(error) {
    // eslint-disable-next-line no-param-reassign
    error.message = `[React] ${error.message}`;
    clientError(error);
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

ErrorBoundary.defaultProps = {
  children: null
};

ErrorBoundary.displayName = 'ErrorBoundary';

export default ErrorBoundary;
